const updatesData = [
  {
    date: '07-28',
    title: '咒术回战 第271话 更新上线',
    desc: '最终决战篇持续推进中，宿傩与虎杖的对决迎来关键转折。',
    tag: '最新更新',
  },
  {
    date: '07-28',
    title: '海贼王 第1134话 同步追更',
    desc: '最终章连载进行时，路飞一伙的新冒险持续展开。',
    tag: '最新更新',
  },
  {
    date: '07-27',
    title: '间谍过家家 第106话 已同步',
    desc: '福杰一家的日常与任务继续，温馨搞笑不间断。',
    tag: '昨日更新',
  },
  {
    date: '07-27',
    title: '坂本日常 第196话 上线',
    desc: '坂本太郎的杀手日常再添新章，动作喜剧精彩继续。',
    tag: '昨日更新',
  },
  {
    date: '07-27',
    title: '怪兽8号 第121话 更新',
    desc: '防卫队的战斗进入白热化阶段，科幻激战不容错过。',
    tag: '昨日更新',
  },
  {
    date: '07-26',
    title: '我推的孩子 第168话 同步',
    desc: '演艺圈背后的真相逐渐浮出水面，剧情持续高能。',
    tag: '本周更新',
  },
  {
    date: '07-26',
    title: '胆大党 第183话 连载更新',
    desc: '灵异与科幻的奇妙碰撞，龙幸伸的异色之作持续发力。',
    tag: '本周更新',
  },
  {
    date: '07-25',
    title: 'UU漫画收录突破12000部',
    desc: '平台持续扩充免费漫画全集资源，最新漫画更新不断加入。',
    tag: '平台动态',
  },
  {
    date: '07-24',
    title: '更新提醒功能全面升级',
    desc: '漫画更新提醒更精准更及时，追更漫画体验再上新台阶。',
    tag: '功能更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            连载漫画最新更新实时追踪，追更漫画动态一手掌握
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>

          <div className="flex flex-col gap-4">
            {updatesData.map((item, i) => (
              <div key={i} className="flex items-start gap-4 sm:gap-6">
                <div className="flex-shrink-0 hidden sm:flex flex-col items-center">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    item.tag === '最新更新' ? 'bg-primary-100 text-primary-500' :
                    item.tag === '昨日更新' ? 'bg-accent-100 text-accent-500' :
                    'bg-secondary-100 text-secondary-500'
                  }`}>
                    <i className={`text-lg ${
                      item.tag === '最新更新' ? 'ri-flashlight-fill' :
                      item.tag === '昨日更新' ? 'ri-time-fill' :
                      'ri-check-double-fill'
                    }`}></i>
                  </div>
                </div>

                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                  <div className="flex-shrink-0 flex items-center gap-2 sm:w-16">
                    <span className="text-xs font-semibold text-foreground-400">{item.date}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className={`text-[10px] px-1.5 py-0.5 rounded font-semibold whitespace-nowrap ${
                        item.tag === '最新更新' ? 'bg-primary-100 text-primary-600' :
                        item.tag === '昨日更新' ? 'bg-accent-100 text-accent-600' :
                        'bg-secondary-100 text-secondary-600'
                      }`}>
                        {item.tag}
                      </span>
                      <h3 className="text-sm font-bold text-foreground-800">{item.title}</h3>
                    </div>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}